<!-- =========================================================================================
    File Name: EmailMailCard.vue
    Description: Email Application - Single Email Card View
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template functional>
  <vx-card class="px-4" :class="data.staticClass">
    <!-- MAIL HEAD -->
    <div class="vx-row">
      <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
        <!-- Sender Details -->
        <div class="flex items-center">
<!--          <div>-->
<!--            <vs-avatar class="sender__avatar&#45;&#45;single flex-shrink-0 mr-3 border-2 border-solid border-white" :src="props.mailContent.img" size="65px" />-->
<!--          </div>-->

          <div class="flex flex-col">
            <h5 class="mb-4">{{ props.notificationContent.title }}</h5>
          </div>
        </div>
        <!-- /Sender Details -->

        <!-- Mail Time & Date -->
<!--        <div class="flex flex-col justify-end">-->
<!--          <span class="text-right">{{ props.mailContent.time | time }}</span>-->
<!--          <div class="flex justify-end mt-2">-->
<!--            <span class="text-right">{{ props.mailContent.time | date(true) }}</span>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <!-- /Mail Time & Date -->
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mail__content break-words mt-8 mb-4" style="white-space: pre-line;" v-html="props.notificationContent.content"></div>
      </div>
    </div>
    <div v-if="props.notificationContent.url" class="vx-row">
      <div class="vx-col w-full">
        <a :href="props.notificationContent.url">{{props.notificationContent.url}}</a>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  props: {
    notificationContent: {
      type: Object,
      required: true
    }
  }
}
</script>
